import React, { Component } from 'react'
import { t } from 'i18n'

class WarrantPaymentStep extends Component {
  constructor(props) {
    super(props)
    this.state = {
      warrant_check: props.warrant_check
    }
  }

  openPaymentWindow() {
    const payment = this.props.warrant_check.payment
    let windowWidth = Math.max(screen.width * 0.7, 820)
    let windowHeight = Math.max(screen.height * 0.7, 720)

    this.paymentWindow = window.open(payment.vraa_url, '', `width=${windowWidth},height=${windowHeight}`)
  }

  renderPaymentLink() {
    return (
      <div className='text-center'>
        <button type='button' className='btn btn-outline btn-lg mt-4' onClick={this.openPaymentWindow.bind(this)}>
          {t('components.warrant_check_container.pay')}
        </button>
      </div>
    )
  }

  renderSpinner() {
    return (
      <span className='loading-indicator'></span>
    )
  }

  render() {
    const { payment } = this.props.warrant_check

    return(
      <div className='payment-screen service-form'>
        <h1 className='h4 text-center mt-5 pt-5'>{t('components.warrant_check_container.payment_heading')}</h1>
        {payment.vraa_url ? this.renderPaymentLink() : this.renderSpinner()}
      </div>
    )
  }
}

export default WarrantPaymentStep
